<div class="grid ">
	<div class="col-12">
		<div class="card">
			<h5>Nova Conta Empresa</h5>
			<button type="button" pButton icon="pi pi-plus" label="Importar" class="p-button-info"
			(click)="abrirDialogConta()">
			</button>
			<form #f="ngForm" name="form" novalidate>
				<div class="formgroup">
					<div class="p-fluid p-formgrid grid">
						<div class="field col-12 md:col-12">
							<p-divider></p-divider>
						</div>
						<div *ngIf="messagemVisivel" class="field col-12 md:col-12">
							<p-messages [(value)]="messages" [enableService]="false" [closable]="true"></p-messages>
						</div>
						<div class="field col-12 md:col-5">
							<label htmlFor="descricao">Descrição da Conta</label>
							<input oninput="this.value = this.value.toUpperCase();" type="text" pInputText
								placeholder="Digite a descrição" name="descricao" ngModel #descricao="ngModel"
								required [readOnly]="modoImportacao"/>
							<div *ngIf="descricao.hasError('required') && descricao.touched" class="alerta">
								<small>Campo obrigatório</small>
							</div>
						</div>
						
						<div class="field col-12 md:col-7">
							<label htmlFor="especificacao">Especificação</label>
							<input oninput="this.value = this.value.toUpperCase();" type="text" pInputText
								placeholder="Digite a especificação" name="especificacao" ngModel
								#especificacao="ngModel" required [readOnly]="modoImportacao"/>
							<div *ngIf="especificacao.hasError('required') && especificacao.touched" class="alerta">
								<small>Campo obrigatório</small>
							</div>
						</div>
						<div class="field col-12 md:col-5">
							<label htmlFor="dre">DRE</label>
							<p-dropdown [options]="dadosDre" [filter]="true"
								placeholder="Selecione" name="dre" ngModel #dre="ngModel"
								[required]="true" [readonly]="modoImportacao">
							</p-dropdown>
							<div *ngIf="dre.hasError('required') && dre.touched" class="alerta">
								<small>Campo obrigatório</small>
							</div>
						</div>
						<div class="field col-12 md:col-7">
							<label htmlFor="planoContaGrupo">Grupo</label>
							<p-dropdown [options]="planosContaGrupos" optionLabel="descricao" [filter]="true"
								placeholder="Selecione" name="planoContaGrupo" ngModel #planoContaGrupo="ngModel"
								[required]="true" [readonly]="modoImportacao">
							</p-dropdown>
							<div *ngIf="planoContaGrupo.hasError('required') && planoContaGrupo.touched" class="alerta">
								<small>Campo obrigatório</small>
							</div>
						</div>
						
						
					</div>
					<div class="p-fluid p-formgrid grid">
						<div class="field col-12 md:col-2" *ngIf="!progressoRequisicao">
							<button type="button" pButton icon="pi pi-check" label="Salvar" (click)="salvar()"
								class="p-button-success mt-5" [disabled]="!f.valid"></button>
						</div>
						<div class="field col-12 md:col-2" *ngIf="progressoRequisicao">
							<button type="button" pButton icon="pi pi-spin pi-spinner" label="Salvando..."
								class="p-button-success mt-5" [disabled]="true"></button>
						</div>
						<div class="field col-12 md:col-8">

						</div>
						<div class="field col-12 md:col-2">
							<button type="button" pButton icon="pi pi-arrow-left" label="Voltar"
								class="p-button-primary mt-5" (click)="voltar()"></button>
						</div>
					</div>
				</div>
			</form>
			<p-dialog header="Importar Conta" [(visible)]="mostrarDialogConta" [modal]="true"
				[style]="{width: '50vw'}" [draggable]="false" [resizable]="false" [closable]="true"
				(onHide)="fecharDialogConta()">
		<div class="card">
			<p-table #dt1 [value]="listaContaMatriz" dataKey="id" [rows]="10" [rowHover]="true"
			styleClass="p-datatable-gridlines" [paginator]="false" responsiveLayout="scroll"
			styleClass=" p-datatable-sm">
			<ng-template pTemplate="header">
				<tr>
					<th>
						<div>
							Descrição
						</div>
					</th>
					<th>
						<div>
							DRE
						</div>
					</th>

					<th>
						<div>
							Importar
						</div>
					</th>
				</tr>
			</ng-template>
			<ng-template pTemplate="body" let-item let-i="rowIndex">
				<tr>
					<td>
						<label class="form-control">{{ item.descricao }}</label>
					</td>
					<td>
						<label class="form-control">{{ item.dre }}</label>
					</td>

					<td>
						<button pButton pRipple pTooltip="Importar Conta" type="button" icon="pi pi-check"
							class="p-button-success" (click)="importarConta(item)">
						</button>
					</td>
				</tr>
			</ng-template>
			</p-table>
		</div>
				<div class="p-fluid p-formgrid grid justify-content-end">
					<div class="field col-12 md:col-3">
						<button type="button" pButton icon="pi pi-times" label="Cancelar" class="p-button-primary"
							(click)="fecharDialogConta()" ></button>
					</div>
				</div>
			</p-dialog>
		</div>
	</div>
</div>